import { BaseInput } from "components/core";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import { OuterBox } from "components/GhiPlanSetup/styles";
import React from "react";

const CorporateBuffer = ({formikProps}) => {
  return (
    <OuterBox>
      <div style={{ marginBottom: "2rem" }}>
        <TpaDetailInputWrapper marginTop="0">
          <BaseInput
            label="Buffer Limit"
            formatToRupee
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "corporate_buffer_limit",
            }}
          />
        </TpaDetailInputWrapper>
      </div>
    </OuterBox>
  );
};
export default CorporateBuffer